import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';

export interface UsuarioLoginDto {
  id: number;
  usuario: {
    id: number;
    username: string;
    pessoa?: {
      id: number;
      nome: string;
      email?: string;
    };
  };
  sessaoToken: string;
  logadoEm: string;
  deslogadoEm?: string | null;
  ultimoAcesso?: string | null;
  ipOrigem?: string;
  userAgent?: string;
  ativo: boolean;
}

/**
 * Lista todas as sessões de login ativas
 */
export async function ListarSessoesAtivas(usuarioId?: number): Promise<UsuarioLoginDto[]> {
  try {
    const params = usuarioId ? { usuarioId } : {};
    const response = await api.get<UsuarioLoginDto[]>(`${Endpoints.AUTH}/sessoes/ativas`, { params });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao listar sessões ativas.');
  }
}

/**
 * Lista o histórico de logins
 */
export async function ListarHistoricoLogins(usuarioId?: number, limit: number = 50): Promise<UsuarioLoginDto[]> {
  try {
    const params: any = { limit };
    if (usuarioId) {
      params.usuarioId = usuarioId;
    }
    const response = await api.get<UsuarioLoginDto[]>(`${Endpoints.AUTH}/sessoes/historico`, { params });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao listar histórico de logins.');
  }
}

/**
 * Encerra uma sessão de login específica
 */
export async function EncerrarSessao(sessaoId: number): Promise<UsuarioLoginDto> {
  try {
    const response = await api.delete<UsuarioLoginDto>(`${Endpoints.AUTH}/sessoes/${sessaoId}`);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao encerrar sessão.');
  }
}

/**
 * Encerra todas as sessões ativas de um usuário
 */
export async function EncerrarTodasSessoes(usuarioId: number): Promise<void> {
  try {
    await api.delete(`${Endpoints.AUTH}/sessoes/usuario/${usuarioId}`);
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao encerrar todas as sessões do usuário.');
  }
}

